module.exports = __webpack_public_path__ + "static/media/computer_gears.dae3062f.webp";